<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { sameAs } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

// keep your component names as used in the template
import umsaekjandi from '../../Shared/Umsaekjandi.vue'
import Step2 from './Step2.vue'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
}>()

// expand first panel by default
const expanded = ref<number[]>([0])
</script>

<template>
  <div v-if="umsokn">
    <v-col sm="12">
      <!-- Header -->
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('umsokn_samantekt_header') }}
          </h2>
        </v-col>
      </v-row>

      <!-- Intro -->
      <v-row>
        <v-col>
          <p>{{ t('umsokn_samantekt_header2') }}</p>
        </v-col>
      </v-row>

      <!-- Summary expansion -->
      <v-row>
          <v-expansion-panels v-model="expanded" multiple>
            <v-expansion-panel>
              <v-expansion-panel-title>
                {{ t('umsokn_samantekt_upplysingar') }}
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div>
                  <umsaekjandi :disable="true" />
                </div>
                <div class="m-t-100">
                  <Step2 :disable="true" />
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
      </v-row>
    </v-col>
  </div>
</template>

<style scoped lang="scss">
.m-t-100 { margin-top: 100px; }
.forms__header {
  color: #194458;
  font-weight: 900;
  font-size: 28px;
  line-height: 1.25;
  margin: 0 0 12px;
}
</style>
